<template>
  <div class="header">
    <div class="hk_logo"></div>
    <div class="top_menu">
      <div
        class="menu_item"
        :class="$route.path.includes(ele.path) ? 'active_item' : ''"
        v-for="(ele, n) in menulist"
        @click="toPage(ele.path)"
        :key="n"
      >
        <div class="text">{{ ele.name }}
        </div>
        <div class="border"></div>
      </div>
      <div class="menu_item menu_icon" @click="open">
        <img src="../../public/header_icon.png" alt="">
      </div>
    </div>

    <div class="hk_logo_new"></div>

    <Dialog ref="dialog"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/dialog.vue';
export default {
  name: "header1",
  components:{
    Dialog
  },
  props: {
    msg: String,
  },
  data() {
    return {
      vsible: false,
      menulist: [
        { name: "关于华科", path: "/aboutHK" },
        { name: "业务领域", path: "/business" },
        { name: "新闻资讯", path: "/news" },
        { name: "数字金融", path: "/digitization" },
        { name: "联系我们", path: "/contactUs" },
      ],
    };
  },
  methods: {
    toPage(path) {
      if(path == '/business'){
        this.$router.push({
        path: path,
        query: {
          active1: 1
        }
      });
      }else{
        this.$router.push({
        path: path,
      });
      }
     
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    },
    open(){
      this.$refs.dialog.open()
    }
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 100px;
  padding-top: 33px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
}

.hk_logo_new {
  width: 176px;
  height: 59px;
  margin-left: 88px;
  background: url('../assets/hk_logo_header.png') no-repeat;
  background-size: 176px 59px;
  position: absolute;
  left: 88px;
  top: 20px;

}

.top_menu {
  display: flex;
  position: absolute;
  right: 88px;
  top: 33px;
}

.menu_item {
  width: 90px;
  height: 40px;
  margin: 0 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* 标准语法 */
  .text {
    width: 100%;
    height: 18px;
    font-size: 16px;
    text-align: center;
    line-height: 18px;
    color: #000;
    margin-top: 10px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .border {
    width: 62px;
    height: 3px;
    background: transparent;
  }
}

.menu_icon{
  width: 40px;
  padding-top: 10px;
  img{
    width: 23px;
    height: 15px;
  }

}

.active_item {
  width: 90px;
  .text {
    font-size: 16px;
    color: #c71723;
    font-weight: bold;
  }
  .border {
    background: #c71723;
  }
}
</style>
